import * as React from 'react';

import { translate } from '~l10n/client';
import { atom, useAtom } from 'jotai';

import { UIButton } from '~shared/components/buttons';
import { DialogConfirmation } from '~shared/components/Dialog';
import { toast } from '~shared/components/Toast';
import { CustomerPortalSessionForm } from '~teacher/components/Account/CustomerPortalSessionForm';
import { calculateSeatsUsed } from '~teacher/components/Account/helpers';
import { useSelectedTeamQuery } from '~teacher/components/Account/hooks';
import { useTeamsMembers } from '~teacher/hook/team';
import { useSubscriptions } from '~teacher/hook/useSubscriptions';

import platform from '../../../../../../../shared/Platform';

export const isSeatsAvailableDialogOpenAtom = atom<boolean>(false);

export function SeatsAvailableDialog() {
  const selectedTeam = useSelectedTeamQuery();
  const selectedTeamId = selectedTeam.data?.id;

  const teamMembers = useTeamsMembers({ teamId: selectedTeamId });
  const totalSeats = useSubscriptions({
    select: (data) => {
      const subscription = data.find(
        ({ id }) => id === selectedTeam.data?.subscriptionId
      );
      return subscription?.totalSeats ?? 0;
    },
  });
  const [isOpen, setIsOpen] = useAtom(isSeatsAvailableDialogOpenAtom);

  const seatsAvailable = calculateSeatsUsed({
    totalSeats: totalSeats.data,
    teamMembers: teamMembers.data,
  });

  const onClose = () => {
    setIsOpen(false);
    toast(translate('{0} Seats Available.').format(seatsAvailable));
  };

  return seatsAvailable <= 0 ? null : (
    <DialogConfirmation
      actions={[
        <CustomerPortalSessionForm
          key="manage-subscription"
          onSubmit={() => setIsOpen(false)}
          source="account_page_teams__seats_available_dialog"
          teamId={selectedTeamId}
        >
          <UIButton type="submit" key="manage-subscription" onClick={() => {}}>
            {translate('Manage Subscription')}
          </UIButton>
          <input
            name="team_id"
            id="team_id"
            value={selectedTeamId}
            readOnly
            hidden
          />
        </CustomerPortalSessionForm>,
        <UIButton onClick={onClose} appearance="primary" key="keep-seats">
          {translate('Keep Seats')}
        </UIButton>,
      ]}
      open={!platform.isWrapperApp() && isOpen}
      onClose={onClose}
      id={'seats-available-dialog'}
      title={translate('Seats Available')}
    >
      {translate(
        'You can keep seats to invite new members, or remove the seats from your Subscription.'
      )}
    </DialogConfirmation>
  );
}
